import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PreFlightHubPage } from "@/features/preflight/pages/PreFlightHubPage";

export const Route = createFileRoute("/_authenticated/pre-flight/")({
  component: PreFlightHubRoute,
});

function PreFlightHubRoute() {
  const navigate = useNavigate();
  return (
    <PreFlightHubPage
      onOpenReport={(reportId, options) =>
        void navigate({
          to: "/pre-flight/reports/$reportId",
          params: { reportId },
          search: options?.exportPdf
            ? { export: "pdf" as const }
            : { export: undefined },
        })
      }
    />
  );
}
